import "./brand-tile.scss";

import React from "react";
import { Link } from "gatsby";

const BrandTile = ({ logo, link, type }) => {
  return (
    <Link to={link}>
      <div className="brand-tile">
        <div className="brand-tile__logo-wrapper">
          <img src={logo} alt="" className="img-fluid brand-tile__logo" />
        </div>
        <div className="brand-tile__type">{type}</div>
      </div>
    </Link>
  );
};

export default BrandTile;
